import { HeadType } from 'components/layout/table/head'

export default {
  head: [
    {
      label: '= Summe des Materialbedarfs aller ausgewählten Positionen',
      key: 'totalPriceNetto',
      unit: 'EUR',
      col: 12,
      type: HeadType.Highlight,
      leftAlign: false,
    },
  ],
  isAggregation: true,
}
